import React from 'react';
import AdminSidebar from './AdminSidebar';
import DashboardHeader from './DashboardHeader';
import { useAuth } from '../../context/AuthContext';

/**
 * Admin Dashboard Layout Component with Sidebar Navigation
 */
const AdminDashboardLayout = ({ children, pageName }) => {
  const { user } = useAuth();

  return (
    <div className="h-screen bg-gray-50 dark:bg-gray-900 flex overflow-hidden transition-colors duration-300">
      {/* Admin Sidebar Navigation */}
      <AdminSidebar />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 h-full">
        {/* Dashboard Header */}
        <DashboardHeader
          pageName={pageName}
          userName={user?.name || user?.email || 'Admin'}
        />

        {/* Main Content */}
        <main className="flex-1 overflow-y-auto pb-20 lg:pb-0">
          <div className="px-6 lg:px-8 xl:px-10 py-8 w-full max-w-none h-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminDashboardLayout;